export default "__VITE_ASSET__5nepLEOi__"